import React from "react";
import { observer, inject } from "mobx-react";
import * as Icon from "react-feather";
// import * as dateFns from "date-fns";
// import DayPickerInput from "react-day-picker/DayPickerInput";
import GroupSelector from "./_common/group-selector";
//import "react-day-picker/lib/style.css";
import * as M from "@material-ui/core";
import * as H from "../helpers";
import { values } from "mobx";

// const intervalPeriods = [
//   { value: "none", label: "Geen" },
//   { value: "day", label: "1 x per dag" },
//   { value: "week", label: "1 x per week" },
//   { value: "month", label: "1 x per maand" },
//   { value: "trimester", label: "1 x per trimester" },
//   { value: "year", label: "1 x per jaar" },
//   { value: "3year", label: "1 x per 3 jaar" },
//   { value: "5year", label: "1 x per 5 jaar" }
// ];

const SurveySettings = props => {
  const { $survey, $locale, $user, $alert, $config, $group } = props.store;

  return (
    $survey.selected && (
      <form
        onSubmit={e => {
          e.preventDefault();
          $survey.selected.fsSave();
        }}
      >
        {props.mode === "settings" && (
          <React.Fragment>
            <h3 className="mb-8">Instellingen</h3>
            <M.Box mb={2}>
              <GroupSelector label="Voor groep/school:" hideCounter={true} />
            </M.Box>
          </React.Fragment>
        )}

        <div className="mt-8 mb-8">
          {$user.sessionUser.isAdmin && (
            <div className="field row mb-4">
              <label>RespondentCount</label>
              <div>
                {$group.selected
                  ? $survey.selected.respondentCountForSelectedGroup
                  : $survey.selected.respondentCount}
              </div>
            </div>
          )}

          {$user.sessionUser.isAdmin && (
            <div className="field row mb-4">
              <label>Key</label>
              <div>{$survey.selected._key}</div>
            </div>
          )}

          {$user.sessionUser.isAdmin && (
            <div className="field row mb-4">
              <label>Created By</label>
              <div>{$survey.selected.createdBy}</div>
            </div>
          )}

          {$user.sessionUser.isVerifiedCreator && !$group.selected && (
            <div className="field row">
              <label>Naam van de vragenlijst</label>
              <M.TextField
                fullWidth
                value={$survey.selected.name}
                name="name"
                disabled={!$user.sessionUser.isVerifiedCreator}
                onChange={$survey.selected.changeAndValidate}
              />
            </div>
          )}

          {$user.sessionUser.isVerifiedCreator && !$group.selected && (
            <div className="field row ">
              <label>Cluster</label>
              <M.TextField
                fullWidth
                value={$survey.selected.cluster || H.slugify($survey.selected.name)}
                name="cluster"
                disabled={!$user.sessionUser.isVerifiedCreator}
                onChange={$survey.selected.changeAndValidate}
                placeholder="Kies hier vrij een naam die gebruikt kan worden om vragenlijsten te bundelen."
              />
            </div>
          )}

          {$user.sessionUser.isVerifiedCreator && $config.id === "obs-barometer" && (
            <div className="field row ">
              <label>Onderwijsniveau</label>
              <M.TextField
                fullWidth
                name="educationLevel"
                select
                value={$survey.selected.educationLevel || "select"}
                onChange={e => $survey.selected.change("educationLevel", e.target.value)}
              >
                {[
                  { label: "Basisonderwijs", value: "basis" },
                  { label: "Secundair onderwijs", value: "secundair" }
                ].map((level, i) => (
                  <M.MenuItem key={i} value={level.value}>
                    {level.label}
                  </M.MenuItem>
                ))}
              </M.TextField>
            </div>
          )}

          {props.mode === "settings" && !$group.selected && (
            <div className="field row my-2">
              <label>Status</label>
              <M.Box display="flex" flexDirection="column">
                <M.FormControlLabel
                  disabled={!$user.sessionUser.isVerifiedCreator}
                  checked={$survey.selected.enabled}
                  onChange={e => {
                    $survey.selected.changeAndValidate(e);
                    if ($survey.selected.enabled) {
                      $survey.selected.change("disabledForGroups", []);
                    } else {
                      $survey.selected.change(
                        "disabledForGroups",
                        values($group.list).map(group => group._key)
                      );
                    }
                  }}
                  control={<M.Switch name={`enabled`} />}
                  label={
                    $survey.selected.enabled
                      ? `Deze vragenlijst is actief`
                      : `Deze vragenlijst is niet actief`
                  }
                />
                <M.FormHelperText>
                  Opgepast! Status wijzigen heeft gevolgen voor de status van alle groepen.
                </M.FormHelperText>
              </M.Box>
            </div>
          )}

          {props.mode === "settings" && $group.selected && (
            <div className="field row my-2">
              <label>Status Groep</label>
              <M.FormControlLabel
                disabled={!$survey.selected.enabled}
                checked={$survey.selected.disabledForGroups.indexOf($group.selected._key) < 0}
                onChange={e => {
                  let disabledForGroups = $survey.selected.disabledForGroups.map(group => group);
                  const index = disabledForGroups.indexOf($group.selected._key);
                  if (index < 0) {
                    $survey.selected.change("disabledForGroups", [
                      ...disabledForGroups,
                      $group.selected._key
                    ]);
                  } else {
                    disabledForGroups.splice(index, 1);
                    $survey.selected.change("disabledForGroups", disabledForGroups);
                  }
                }}
                control={<M.Switch />}
                label={
                  $survey.selected.disabledForGroups.indexOf($group.selected._key) < 0
                    ? `Deze vragenlijst is actief ${
                        $group.selected ? "voor " + $group.selected.name : ""
                      }`
                    : `Deze vragenlijst is niet actief ${
                        $group.selected ? "voor " + $group.selected.name : ""
                      }`
                }
              />
            </div>
          )}

          {props.mode === "settings" && !$group.selected && $config.id === "obs-barometer" && (
            <div className="field row">
              <label>Groep</label>
              <M.FormControlLabel
                disabled={!$user.sessionUser.isVerifiedCreator}
                checked={$survey.selected.questions_for_group}
                onChange={$survey.selected.changeAndValidate}
                control={<M.Checkbox name="questions_for_group" />}
                label="Begeleiders kunnen groepspecifieke vragen toevoegen"
              />
            </div>
          )}

          {props.mode === "settings" && !$group.selected && (
            <div className="field row mb-4 mt-3">
              <label>Talen</label>
              <M.Box display="flex" flexWrap="wrap">
                {$config.languages.map(language => (
                  <div className="w-1/2" key={language.key}>
                    <M.FormControlLabel
                      disabled={
                        !$user.sessionUser.isVerifiedCreator || $config.languages.length < 2
                      }
                      control={
                        <M.Checkbox
                          value={language.key}
                          checked={$survey.selected.languages.split(",").indexOf(language.key) > -1}
                          name="languages"
                          onChange={$survey.selected.changeLanguages}
                        />
                      }
                      label={$locale.getLanguageLabelForKey(language.key, "NL")}
                    />
                  </div>
                ))}
              </M.Box>
            </div>
          )}

          {props.mode === "settings" && !$group.selected && (
            <React.Fragment>
              <div className="mb-8">
                <label>Intropagina Titel</label>
                {$survey.selected.languages.split(",").map(
                  (language, i) =>
                    language && (
                      <M.TextField
                        multiline
                        rows="5"
                        fullWidth
                        name="surveyName"
                        key={language}
                        label={$locale.getLanguageLabelForKey(language, "NL")}
                        value={$locale.t($survey.selected._key + "_surveyName", language, false)}
                        onChange={event => {
                          $locale.setSelected(
                            $survey.selected._key + "_surveyName",
                            language,
                            event.target.value
                          );
                        }}
                      />
                    )
                )}
              </div>
              <div className="mb-8">
                <label>Intropagina Omschrijving</label>
                {$survey.selected.languages.split(",").map(
                  (language, i) =>
                    language && (
                      <M.TextField
                        multiline
                        rows="5"
                        fullWidth
                        name="introText"
                        key={language}
                        label={$locale.getLanguageLabelForKey(language, "NL")}
                        value={$locale.t($survey.selected._key + "_introText", language, false)}
                        onChange={event => {
                          $locale.setSelected(
                            $survey.selected._key + "_introText",
                            language,
                            event.target.value
                          );
                        }}
                      />
                    )
                )}
              </div>
              <div className="mb-8">
                <label>Boodschap inactief</label>
                {$survey.selected.languages.split(",").map(
                  (language, i) =>
                    language && (
                      <M.TextField
                        multiline
                        rows="5"
                        fullWidth
                        name="inActive"
                        key={language}
                        label={$locale.getLanguageLabelForKey(language, "NL")}
                        value={$locale.t($survey.selected._key + "_inActive", language, false)}
                        onChange={event => {
                          $locale.setSelected(
                            $survey.selected._key + "_inActive",
                            language,
                            event.target.value
                          );
                        }}
                      />
                    )
                )}
              </div>
              <div className="mb-8">
                <label>Delen Suggestietekst</label>
                {$survey.selected.languages.split(",").map(
                  (language, i) =>
                    language && (
                      <M.TextField
                        multiline
                        rows="5"
                        fullWidth
                        name="delen"
                        key={language}
                        label={$locale.getLanguageLabelForKey(language, "NL")}
                        value={$locale.t($survey.selected._key + "_delen", language, false)}
                        onChange={event => {
                          $locale.setSelected(
                            $survey.selected._key + "_delen",
                            language,
                            event.target.value
                          );
                        }}
                      />
                    )
                )}
              </div>
              <div className="mb-8">
                <label>Algemene Feedback na invullen vragenlijst</label>
                {$survey.selected.languages.split(",").map(
                  (language, i) =>
                    language && (
                      <M.TextField
                        multiline
                        rows="5"
                        fullWidth
                        name="feedback"
                        key={language}
                        label={$locale.getLanguageLabelForKey(language, "NL")}
                        value={$locale.t($survey.selected._key + "_feedback", language, false)}
                        onChange={event => {
                          $locale.setSelected(
                            $survey.selected._key + "_feedback",
                            language,
                            event.target.value
                          );
                        }}
                      />
                    )
                )}
              </div>
            </React.Fragment>
          )}
        </div>
        {$user.sessionUser.isVerifiedMentor && $survey.selected._key !== "new" && (
          <div
            className="fixed px-8 py-4 bg-gray-lightest z-10 flex justify-between"
            style={{
              left: "250px",
              bottom: "0px",
              width: "calc(100% - 250px)"
            }}
          >
            <M.Button type="submit" disabled={$alert.list.size > 0} startIcon={<Icon.Save />}>
              Bewaren
            </M.Button>
            {$user.sessionUser.isAdmin && (
              <M.Button onClick={() => $survey.selected.syncRespondentCount()}>
                SYNC RESPONDENTCOUNT
              </M.Button>
            )}
          </div>
        )}
      </form>
    )
  );
};

export default inject("store")(observer(SurveySettings));
